import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser'
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, debounceTime, tap, filter, switchMap, finalize } from 'rxjs/operators';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { MenuFuncionService, IncidenciaUsuarioService, ComunidadService, IncidenciaUsuarioCategoriaService, UsuarioService, TipoDocumentoService, PersonaService, ProveedorService, PedidoService, ContratoService, UnidadFuncionalService } from '../../../../../src/app/shared/services/index';
import { MenuFuncionCodes, IncidenciaUsuario, SearchEstadoResponse, SaveIncidenciaHilo, ViewHilosRequestDto, SearchIncidenciaHiloItemDto, IncidenciaHiloAdjunto, SearchComunidadRequest, LocalStorageKeys, Contrato, SearchContratoRequest, UnidadFuncional, SearchUnidadFuncionalRequest,
  Comunidad, SearchIncidenciaUsuarioCategoriaRequest, IncidenciaUsuarioCategoria, SaveIncidenciaUsuario, SearchUsuariosRequestDto, Persona, SearchTipoDocumentoRequest, TipoDocumento,
  DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, SearchProveedorRequest, Proveedor, SearchPedidoRequestDto, PedidoDto, PedidoEntregasItemDto, IncidenciaUsuarioCategoriaCustomDto, IncidenciaUsuarioCategoriaDto, IncidenciaUsuarioCampoCustom, SaveIncidenciaUsuarioCampoCustom
 } from '../../../../../src/app/shared/model';

import { DialogPersonaSearchComponent } from '../../usuarios/components/dialogPersonaSearch.component';

@Component({
    selector: 'app-incidenciaUsuarioEdit',
    templateUrl: './incidenciaUsuarioEdit.component.html',
    styleUrls: ['./incidenciaUsuarioLista.component.scss']
})

export class IncidenciaUsuarioEditComponent implements OnInit{
    public tools: object = {};
    public insertImageSettings: object = {};

    formGroup: FormGroup;
    formResponse: FormGroup;

    debeEnviarMail: boolean = false;
    esNuevo: boolean = true;
    isValidating: boolean = false;
    isSearching: boolean = false;
    isHiloSearching: boolean = false;
    isAttachmentSearching: boolean = false;
    isSaving: boolean = false;
    isDeleting: boolean = false;
    isClosed: boolean = false;
    isFileAttaching: boolean = false;
    isSubCategoriaSearching: boolean = false;
    isComunidadSearching: boolean = false;
    isUsuarioSearching: boolean = false;
    isTipoDocumentoSearching: boolean = false;
    isCategoriaSearching: boolean = false;
    isPersonSaving: boolean = false;
    isPersonaSearching: boolean = false;
    isProveedorAutoSearching: boolean = false;
    isContratoAutoSearching: boolean = false;
    isPedidoAutoSearching: boolean = false;
    isUnidadesFuncionalesSearching: boolean = false;

    canEdit: boolean = false;
    canDelete: boolean = false;
    canPersonEdit: boolean = false;
    canGestionarIncidencia: boolean = false;
    canAsociarComunidad: boolean = false;
    canAsociarPedido: boolean = false;
    canAsociarPersona: boolean = false;
    canAsociarProveedor: boolean = false;
    canAsociarContrato: boolean = false;
    canAsociarUnidadFuncional: boolean = false;

    filteredPedidoList: PedidoDto[] = [];
    filteredProveedorList: Proveedor[] = [];
    filteredContratoList: Contrato[] = [];
    comunidadList: Comunidad[];
    ufList: UnidadFuncional[];
    persona: Persona = new Persona(0, null, null, null, null, null, null, null, null,null, true, null, null, null);

    categoriaList: IncidenciaUsuarioCategoriaDto[];
    subCategoriasList: IncidenciaUsuarioCategoria[] = [];
    categoriaCamposCustomList: IncidenciaUsuarioCategoriaCustomDto[];
    tipoDocumentoList: TipoDocumento[];

    destinatarios: string = "";
    mailProveedor: string = "";
    mailPersona: string = "";
    msgError: string = "";
    estadoList: SearchEstadoResponse[];
    hiloList: SearchIncidenciaHiloItemDto[];
    item: IncidenciaUsuario;
    newMensaje: SaveIncidenciaHilo;
    adjuntosList: IncidenciaHiloAdjunto[];

    loggedUserId: number;
    hasSearched: boolean = false;
    pageNumber: number = -1;
    usuarioList: any[];
    filteredUsuarioList: any[];
    incidenciaUsuarioSubCategoriaId: number | null;
    personaFormGroup: FormGroup;
    personaMsgError: string;
    camposCustomGroup: FormGroup;
    codigoRequerido: boolean = false;
    categoriaUsuarioCamposCustom: IncidenciaUsuarioCampoCustom[];

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private location: Location,
        public dialog: MatDialog,
        private sharedFunctions: SharedFunctions,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private menuFuncionService: MenuFuncionService,
        private comunidadService: ComunidadService,
        private unidadFuncionalService: UnidadFuncionalService,
        private categoriaService: IncidenciaUsuarioCategoriaService,
        private incidenciaUsuarioService: IncidenciaUsuarioService,
        public tipoDocumentoService: TipoDocumentoService,
        private usuarioService: UsuarioService,
        private personaService: PersonaService,
        private proveedorService: ProveedorService,
        private contratoService: ContratoService,
        private pedidoService: PedidoService,
        private datePipe: DatePipe,
    ) {
    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data?.Result) {
                this.isValidating = false;
                this.canEdit = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_EDIT);
                this.canGestionarIncidencia = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_EDIT_BO);

                this.canAsociarComunidad = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_COMUNIDAD);
                this.canAsociarPedido = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_PEDIDO);
                this.canAsociarPersona = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_PERSONA);
                this.canAsociarProveedor = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_PROVEEDOR);
                this.canAsociarContrato = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_CONTRATO);
                this.canAsociarUnidadFuncional = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_UF);

                this.loadView();
            }
            else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
        this.tools = this.sharedFunctions.getRichTextToolbarItems();
        this.insertImageSettings = this.sharedFunctions.getRichTextImageSettings
        (
            "incidenciahilo", //this.incidenciaUsuarioService.getResourceName(),
            this.incidenciaUsuarioService.uploadAttachTempUrl()
        )?? {};
    }

    loadView() {
        var loggedUser = this.sharedFunctions.getLoggedUser();
         this.loggedUserId = loggedUser?.Id ?? 0;

        this.menuFuncionService.checkMenu(MenuFuncionCodes.PERSONA_EDIT).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data?.Result) {
                this.canPersonEdit = true;
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err);
        });

        this.buildForm();
        this.buildPersonForm();

        this.getComunidades();
        this.getCategorias();
        this.getTiposDocumento();

        this.getProveedoresAutocomplete();
        this.getPedidosAutocomplete();
        this.getContratosAutocomplete();
        this.getUsuariosAutocomplete();

        this.loadEntity();
    }

    getProveedoresAutocomplete() {
        if (!this.canAsociarProveedor)
            return false;

        this.formGroup.get('Proveedor')?.valueChanges
          .pipe(
            filter(res => {
              return res && res !== null && res.length >= 3
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {
              this.filteredProveedorList = [];
              this.isProveedorAutoSearching = true;
            }),
            switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
              .pipe(
                finalize(() => {
                  this.isProveedorAutoSearching = false;
                }),
              )
            )
          )
          .subscribe((data: any) => {
            this.isProveedorAutoSearching = false;
            if (data != null && data.result != null){
                this.filteredProveedorList = data.result;
                console.log(this.filteredProveedorList)
            }
            else
              this.filteredProveedorList = [];
            // (this.filteredProveedorList, 'lista proveedor')
          });
    }

    getPedidosAutocomplete() {
        if (!this.canAsociarPedido)
            return false;

        this.formGroup.get('Pedido')?.valueChanges
          .pipe(
            filter(res => {
              return res && res !== null && res.length >= 1
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {
              this.filteredPedidoList = [];
              this.isPedidoAutoSearching = true;
            }),
            switchMap(value => this.pedidoService.search(new SearchPedidoRequestDto(null, null, true, "Id", isNumber(parseInt(value)) ? value : null, null, null, null, null, true, null, true, null))
              .pipe(
                finalize(() => {
                  this.isPedidoAutoSearching = false;
                }),
              )
            )
          )
          .subscribe((data: any) => {
            if (data != null && data.result != null)
              this.filteredPedidoList = data.result;
            else
              this.filteredPedidoList = [];
            // (this.filteredProveedorList, 'lista proveedor')
          });
    }

    getContratosAutocomplete() {
        if (!this.canAsociarContrato)
            return false;

        this.formGroup.get('Contrato')?.valueChanges
            .pipe(
                filter(res => {
                    return res && res !== null && res.length >= 1
                }),
                distinctUntilChanged(),
                debounceTime(1000),
                tap(() => {
                    this.filteredContratoList = [];
                    this.isContratoAutoSearching = true;
                }),
                switchMap(value => this.contratoService.search(new SearchContratoRequest(null, null, true, "Codigo", value, null, null, null, null, null, null, null, null, null, null, true))
                    .pipe(
                        finalize(() => {
                            this.isContratoAutoSearching = false;
                        }),
                    )
                )
            )
            .subscribe((data: any) => {
                if (data != null && data.result != null)
                    this.filteredContratoList = data.result;
                else
                    this.filteredContratoList = [];
                // (this.filteredContratoList, 'lista contrato')
            });
    }

    getUsuariosAutocomplete() {
        if (!this.canGestionarIncidencia)
            return false;

        this.formGroup.get('UsuarioAsignado')?.valueChanges
          .pipe(
            filter(res => {
              return res && res !== null && res.length >= 3
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {
              this.filteredUsuarioList = [];
              this.isUsuarioSearching = true;
            }),
            switchMap(value => this.usuarioService.search(new SearchUsuariosRequestDto(null, null, true, "Login", value, null, null, null, null, null, null, null, null, true, null))
              .pipe(
                finalize(() => {
                  this.isUsuarioSearching = false;
                }),
              )
            )
          )
          .subscribe((data: any) => {
            if (data != null && data.result != null)
              this.filteredUsuarioList = data.result;
            else
              this.filteredUsuarioList = [];
            // (this.filteredProveedorList, 'lista proveedor')
          });
    }

    getSubCategorias() {
        var categoriaId = this.formGroup.get("IncidenciaUsuarioCategoriaId")?.value;
        if (categoriaId != null && categoriaId > 0) {
            this.isSubCategoriaSearching = true;
            this.categoriaService.getSubCategorias(categoriaId).subscribe(data => {
                this.isSubCategoriaSearching = false;
                this.subCategoriasList = data?.Result;
                this.getCategoriaCamposCustom();
            },
            (err: HttpErrorResponse) => {
                this.isSubCategoriaSearching = false;
                this.sharedFunctions.handleError(err);
            })
        }
    }

    filterUsuarioList(value) {
        const filterValue = value.toLowerCase();
        this.filteredUsuarioList = this.usuarioList.filter(x =>
            x.Nombre.toLowerCase().includes(filterValue) ||
            x.Apellido.toLowerCase().includes(filterValue) ||
            (x.Apellido + " " + x.Nombre).toLowerCase().includes(filterValue) ||
            (x.Nombre + " " + x.Apellido).toLowerCase().includes(filterValue));
    }

    onFiltroUfComunidadSelect(clearUf: boolean = true) {
        if (!this.canAsociarUnidadFuncional)
            return;

        if (clearUf)
            this.formGroup?.get("UnidadFuncionalId")?.setValue(null);

        var cId = this.formGroup?.get("ComunidadId")?.value;
        if (cId == null || cId <= 0) {
            this.ufList = [];
            return false;
        }

        var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
        this.isUnidadesFuncionalesSearching = true;

        this.unidadFuncionalService.search(r).subscribe(data => {
            this.isUnidadesFuncionalesSearching = false;
            this.ufList = data.result;
        },
        (err: HttpErrorResponse) => {
            this.isUnidadesFuncionalesSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    displayUsuario(usuario: any): string {
        return usuario != null ? usuario.Login + " - " + (usuario.Nombre ?? "") + " " + (usuario.Apellido ?? "") : '';
    }

    displayProveedor(proveedor: Proveedor): string {
        return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
    }

    displayContrato(item: any): string {
        return item && item.Id != null && item.Id > 0 ? item.Codigo : '';
    }

    displayPedido(item: any): string {
        return item && item.Id != null && item.Id > 0 ? ("#" + item.Id + " - " +  item.ComunidadOrigenNombre + " > " + item.ComunidadDestinoNombre) : '';
    }

    clearDate(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
                this.formGroup.get(formFieldName)?.setValue(null);
        }
    }

    buildForm() {
        this.formGroup = this.formBuilder.group({
            'IncidenciaUsuarioCategoriaId': [null, Validators.required],
            'Asunto': [null, [Validators.required, Validators.maxLength(150)]],
            'ComunidadId': [null],
            'UnidadFuncionalId': [null],
            'FechaLimite': [null],
            'Pedido': [null],
            'PedidoId': [null],
            'ProveedorId': [null],
            'Proveedor': [null],
            'Contrato': [null],
            'UsuarioAsignadoId': [null],
            'UsuarioAsignado': [null],
            'Codigo': [null]
        });

        this.formResponse = this.formBuilder.group({
            'Mensaje': [null, Validators.required]
        });
    }

    getCategorias() {
        var r = new SearchIncidenciaUsuarioCategoriaRequest(null, null, true, "Nombre", null, null, true, true);
        this.isCategoriaSearching = true;

        this.categoriaService.search(r).subscribe(data => {
            this.isCategoriaSearching = false;
            this.categoriaList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isCategoriaSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    getComunidades() {
        var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
        if (cId != null && cId.length > 0 && cId > 0)
            cId = Number(cId);

        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
            this.isComunidadSearching = false;
            if (data != null)
                this.comunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    onCategoriaSelect() {
        this.incidenciaUsuarioSubCategoriaId = null;
        this.codigoRequerido = this.categoriaList.find(x=>x.Id == this.formGroup.value.IncidenciaUsuarioCategoriaId)?.CodigoRequerido ?? false;
        if(this.codigoRequerido){
            this.formGroup.get('Codigo')?.setValidators(Validators.required);
            this.formGroup.get('Codigo')?.updateValueAndValidity();
        }else{
            this.formGroup.get('Codigo')?.setValidators(null);
            this.formGroup.get('Codigo')?.updateValueAndValidity();
        }
        this.getCategoriaCamposCustom();
        this.getSubCategorias();
    }

    getCategoriaCamposCustom(){
        this.categoriaCamposCustomList = this.categoriaList.find(x => x.Id == this.formGroup.value.IncidenciaUsuarioCategoriaId)?.IncidenciaUsuarioCategoriaCustomDtos ?? [];
        if(this.categoriaCamposCustomList?.length > 0){
            this.camposCustomGroup = this.formBuilder.group({});
            this.categoriaCamposCustomList.forEach(element => {
              if (element.NombreCampo)
                if(element.Requerido){
                    this.camposCustomGroup.addControl(element.NombreCampo, new FormControl(this.item?.IncidenciaUsuarioCampoCustom?.find(x => x.IncidenciaUsuarioCategoriaCustomId == element.Id)?.Valor ?? '', Validators.required))
                }
                else{
                    this.camposCustomGroup.addControl(element.NombreCampo, new FormControl(this.item?.IncidenciaUsuarioCampoCustom?.find(x => x.IncidenciaUsuarioCategoriaCustomId == element.Id)?.Valor ?? ''))
                }
            });
        }
    }

    loadEntity() {
        this.newMensaje = new SaveIncidenciaHilo(null, null, null, [], []);
        this.route.params.subscribe(params => {
            // console.log(params);
            if (params['id'] != null && params['id'] != '0') {
                var id = Number(params['id']);

                if (id > 0) {
                    this.isSearching = true;
                    this.incidenciaUsuarioService.get(id).subscribe(data => {
                        this.isSearching = false;
                        if (data != null && data.Success) {
                            this.item = data.Result;
                            if (this.item != null && this.item.Id > 0) {
                                this.esNuevo = false;
                                this.loadHilos();
                                this.onFiltroUfComunidadSelect(false);

                                if (this.item.PersonaId !== null && this.item.PersonaId > 0)
                                    this.getPersona();

                                this.categoriaCamposCustomList = this.item.IncidenciaUsuarioCategoriaCustom;
                                this.categoriaUsuarioCamposCustom = this.item.IncidenciaUsuarioCampoCustom;
                            }
                            else
                                this.msgError = "No se encontró el incidente seleccionado.";
                        }
                        else
                            this.msgError = "Ocurrió un error al intentar obtener los datos del incidente.";
                    },
                    (err: HttpErrorResponse) => {
                        this.isSearching = false;
                        this.sharedFunctions.handleError(err, true);
                    })
                }
                else
                    this.msgError = "Item no válido.";
            }
            else {
                var loggedUser = this.sharedFunctions.getLoggedUser();
                var pedidoId = Number(params['pedidoId']);
                var proveedorId = Number(params['proveedorId']);
                var faltante = Number(params['faltante']);

                if (faltante == 1)
                    this.getPedidoEntregas(pedidoId, proveedorId);
                if(loggedUser)
                this.item = new IncidenciaUsuario(0, new Date(), null, null, null, null, null, loggedUser?.Id, loggedUser?.Persona?.Nombre ?? '',
                    loggedUser?.Persona?.Apellido ?? '', loggedUser?.Login, null, null, null, null, null, null, null, null, null, (proveedorId > 0 ? proveedorId : null), null,
                    (pedidoId > 0 ? pedidoId : null), null, null, null, null, null, null, true, null, [], []);
                this.formGroup.patchValue(this.item);

                if (proveedorId != null && proveedorId > 0)
                    this.setProveedorForm();
                if (pedidoId != null && pedidoId > 0)
                    this.setPedidoForm();
            }
        });
    }

    setProveedorForm() {
        if (this.item.ProveedorId != null && this.item.ProveedorId > 0) {
            this.isProveedorAutoSearching = true;
            this.proveedorService.get(this.item.ProveedorId).subscribe(data => {
                this.isProveedorAutoSearching = false;
                if (data != null && data.Success) {
                    this.filteredProveedorList = [data.Result];
                    this.formGroup.get("Proveedor")?.setValue(data.Result);
                }
            },
            (err: HttpErrorResponse) => {
                this.isProveedorAutoSearching = true;
                this.sharedFunctions.handleError(err, true);
            })
        }
    }

    setPedidoForm() {
        if (this.item.PedidoId != null && this.item.PedidoId > 0) {
            this.isPedidoAutoSearching = true;
            this.pedidoService.get(this.item.PedidoId).subscribe(data => {
                this.isPedidoAutoSearching = false;
                if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
                    this.filteredPedidoList = [data.Result];
                    this.formGroup.get("Pedido")?.setValue(data.Result);
                }
            },
            (err: HttpErrorResponse) => {
                this.isPedidoAutoSearching = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    }

    getErrorAsunto() {
        var v = this.formGroup.get('Asunto');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorIncidenciaUsuarioCategoriaId() {
        return this.formGroup.get('IncidenciaUsuarioCategoriaId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    markHiloAsRead(id) {
        this.incidenciaUsuarioService.markHiloAsRead(id).subscribe(data => {
            if (data != null && data.Success)
                this.incidenciaUsuarioService.informMessageRead(id);
        },
            (err: HttpErrorResponse) => {
                this.sharedFunctions.handleError(err);
            })
    }

    loadHilos() {

        this.hasSearched = true;
        this.pageNumber++;

        var search = new ViewHilosRequestDto(10, this.pageNumber, true, "FechaCreacion", this.item.Id);
        this.isHiloSearching = true;

        this.incidenciaUsuarioService.viewHilos(search).subscribe(data => {
            this.isHiloSearching = false;
            if (data != null) {
                if (data.result != null && data.result.length > 0) {
                    if (this.hiloList == null)
                        this.hiloList = [];

                    for (var i = 0; i < data.result.length; i++) {
                        data.result[i].MensajeHtml = this.sanitizer.bypassSecurityTrustHtml(data.result[i].Mensaje || '');
                        data.result[i].Adjuntos = data.result[i].Adjuntos?.filter(f => !f.IncluidoEnCuerpoMensaje);

                        if (!data.result[i].Leido)
                            this.markHiloAsRead(data.result[i].Id);

                        this.hiloList.push(data.result[i]);

                        if (this.pageNumber == 0)
                            this.scrollearAlFinal();
                    }
                }
            }
            else
                this.msgError = "Ocurrió un error al intentar obtener los datos de los hilos.";
        },
        (err: HttpErrorResponse) => {
            this.isHiloSearching = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    scrollearAlFinal() {
        setTimeout(() => {
            var objDiv = document.getElementById("hiloMensajesDiv");
            if (objDiv != null)
                objDiv.scrollTop = objDiv.scrollHeight;
        }, 500);
    }

    onCancel() {
        this.location.back();
    }

    isProcessing() {
        return (this.isSearching || this.isSaving);
    }

    mostrarTabAsociaciones() {
        if (this.canAsociarComunidad || this.canAsociarPedido || this.canAsociarPersona || this.canAsociarProveedor || this.canAsociarContrato || this.canAsociarUnidadFuncional) {
            if (this.item != null && this.item.Id > 0) {
                return ((this.item.ComunidadId ?? 0) > 0 || (this.item.PedidoId ?? 0) > 0 || (this.item.UnidadFuncionalId ?? 0) > 0 ||
                            (this.item.PersonaId ?? 0) > 0 || (this.item.ProveedorId ?? 0) > 0 || (this.item.ContratoId ?? 0) > 0);
            }
            else
                return true;
        }
        return false;
    }

    onUsuarioAsignadoChange() {
        this.formGroup.get("UsuarioAsignadoId")?.setValue(null);
        if (this.formGroup.get("UsuarioAsignado")?.value != null){
            this.formGroup.get("UsuarioAsignadoId")?.setValue(this.formGroup.get("UsuarioAsignado")?.value?.Id);
            this.mailPersona = this.formGroup.get("UsuarioAsignado")?.value?.PersonaContactoMail;
        }

    }

    onProveedorChange() {
        this.formGroup.get("ProveedorId")?.setValue(null);
        if (this.formGroup.get("Proveedor")?.value != null){
            this.formGroup.get("ProveedorId")?.setValue(this.formGroup.get("Proveedor")?.value?.Id);
            this.mailProveedor = this.formGroup.get("Proveedor")?.value?.PersonaContactoMail;

        }
    }

    getPedidoEntregas(pedidoId: number, proveedorId: number) {
        if (pedidoId == null || pedidoId <= 0)
          return false;

        this.pedidoService.getPedidoEntregas(pedidoId).subscribe(data => {
          var pedidoEntregasDto = data?.Result;
          if (pedidoEntregasDto != null && pedidoEntregasDto.HayPendientesEntrega && pedidoEntregasDto.Materiales != null && pedidoEntregasDto.Materiales.length > 0) {
            var listaFaltantes = pedidoEntregasDto.Materiales.filter(f => f.Diferencia != 0);
            if (proveedorId != null && proveedorId > 0)
                listaFaltantes = listaFaltantes.filter(f => f.ProveedorId == proveedorId);
            // console.log(listaFaltantes);

            if (listaFaltantes != null && listaFaltantes.length > 0) {
                var mensaje = this.generarMensajeDeFaltantes(listaFaltantes);
                // console.log(mensaje);
                this.formResponse.patchValue({ Mensaje: mensaje });
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.sharedFunctions.handleError(err);
        });
    }

    generarMensajeDeFaltantes(listaFaltantes: PedidoEntregasItemDto[]): string {
        let mensaje = "Los siguientes materiales no fueron entregados todavía:<br/>";
        let tabla = `<table style="border: 1px solid black;">
                      <thead style="border: 1px solid black;">
                        <tr style="border: 1px solid black;">
                          <th style="text-align: center; border: 1px solid black;">Material</th>
                          <th style="text-align: center; border: 1px solid black;">Cantidad Solicitada</th>
                          <th style="text-align: center; border: 1px solid black;">Faltante</th>
                        </tr>
                      </thead>
                      <tbody style="border: 1px solid black;">`;

        for (const item of listaFaltantes) {
          tabla += `<tr style="border: 1px solid black;">
                      <td style="text-align: center; border: 1px solid black;">${item.MaterialNombre}</td>
                      <td style="text-align: right; border: 1px solid black;">${item.CantidadPedida}</td>
                      <td style="text-align: right; border: 1px solid black;">${item.Diferencia}</td>
                    </tr>`;
        }

        tabla += `</tbody>
                  </table>`;

        return mensaje + tabla;
    }

    onGuardar() {

        if (this.esNuevo) {
            if (!this.formGroup.valid) {
                this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para cargar la incidencia", "Error");
                return false;
            }
        }

        if (this.camposCustomGroup && !this.camposCustomGroup?.valid && this.getCampoActivo()) {
            this.sharedFunctions.showMessage("Por favor complete los campos obligatorios de los Datos Adicionales para continuar", "Error");
            return false;
        }

        if (!this.formResponse.valid) {
            this.sharedFunctions.showMessage("Por favor escriba un mensaje para continuar", "Error");
            return false;
        }

        if (this.esNuevo)
            this.doSave();
        else
            this.doSaveHilo();
    }

    onSaveCategoriaCamposCustom(): SaveIncidenciaUsuarioCampoCustom[]{
        var saveCamposCustom: SaveIncidenciaUsuarioCampoCustom[] = [];
        if(this.categoriaCamposCustomList?.length > 0){
            this.categoriaCamposCustomList.forEach(value => {
                if(value.Activo && value.NombreCampo){
                    var campoCustom = new SaveIncidenciaUsuarioCampoCustom(0, this.camposCustomGroup.value[value.NombreCampo], value.Id, this.item.Id, true);
                    saveCamposCustom.push(campoCustom);
                }
            });
        }
        return saveCamposCustom;
    }

    doSave() {
        this.onProveedorChange();
        this.onUsuarioAsignadoChange();

        var camposCustom = this.onSaveCategoriaCamposCustom();
        var r = new SaveIncidenciaUsuario(null, null, null, null, null, null, null, null, null, [], [], []);

        if (this.adjuntosList == null)
            this.adjuntosList = [];
        if(camposCustom == null || camposCustom?.length == 0)
            camposCustom = [];
        r =
        {
            ...this.formGroup.value,
            ...this.formResponse.value,
            ...
            {
                Id: (this.item?.Id ?? 0),
                Adjuntos: this.adjuntosList,
                IncidenciaUsuarioCampoCustoms: camposCustom,
                IncidenciaUsuarioCategoriaId: this.incidenciaUsuarioSubCategoriaId ? this.incidenciaUsuarioSubCategoriaId : this.formGroup.value.IncidenciaUsuarioCategoriaId,
                PersonaId: this.persona?.Id,
                Persona: this.personaFormGroup?.getRawValue(),
                PedidoId: this.formGroup.get("Pedido")?.value?.Id,
                ContratoId: this.formGroup.get("Contrato")?.value?.Id,
                EnviarMail: this.debeEnviarMail,
                Destinatarios: this.destinatarios,
            }
        };

        this.isSaving = true;
        this.incidenciaUsuarioService.save(r).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success) {
                this.sharedFunctions.showMessage("Se guardó exitosamente la incidencia bajo el número " + data.Result?.Id + "!", "Operación Exitosa!");
                this.onCancel();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    doSaveHilo() {
        var r = new SaveIncidenciaHilo(null, null, null, [], []);

        if (this.adjuntosList == null)
            this.adjuntosList = [];

        r =
        {
            ...this.formResponse.value,
            ...{
                IncidenciaId: (this.item?.Id ?? 0),
                Adjuntos: this.adjuntosList
            }
        };

        this.isSaving = true;
        this.incidenciaUsuarioService.saveHilo(r).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success) {
                this.sharedFunctions.showMessage("Se guardó exitosamente la respuesta!", "Operación Exitosa!");
                this.sharedFunctions.reloadCurrentRoute();
                // this.formResponse.reset();
                // this.adjuntosList = [];

                // this.pageNumber = -1;
                // this.loadHilos();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    onFileAttachedDelete(item: any) {
        if (item.Id > 0)
            this.onExistingFileAttachedDelete(item);
        else
            this.onNewFileAttachedDelete(item);
    }

    onNewFileAttach(event: any) {
        if (event?.target?.files != null && event.target.files.length > 0) {
            var fileList = event.target.files;

            if (this.adjuntosList == null)
                this.adjuntosList = [];

            for (var i = 0; i < fileList.length; i++) {
                if (this.adjuntosList.find(f => f.NombreDocumento == fileList[i].name)) {
                    this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
                    return false;
                }
            }

            if (fileList != null && fileList.length > 0) {
                this.isFileAttaching = true;
                this.incidenciaUsuarioService.uploadAttachTemp(fileList).subscribe(data => {
                    this.isFileAttaching = false;
                    if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
                        for (let i = 0; i < data.Result.Archivos.length; i++) {
                            if (data.Result.Archivos[i] != null) {
                                this.adjuntosList.push(data.Result.Archivos[i]);
                            }
                        }
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
                },
                    (err: HttpErrorResponse) => {
                        this.isFileAttaching = false;
                        this.sharedFunctions.handleError(err, true);
                    })
            }
        }
    }

    onExistingFileAttachedDelete(item: any) {
        if (this.adjuntosList != null && this.adjuntosList.length > 0) {
            var index = this.adjuntosList.findIndex(f => f.Id == item.Id);

            if (index >= 0)
                this.adjuntosList.splice(index, 1);
        }
    }

    onNewFileAttachedDelete(item: any) {
        if (this.adjuntosList != null && this.adjuntosList.length > 0) {
            var index = this.adjuntosList.findIndex(f => f.Id == item.Id);

            if (index >= 0) {
                this.adjuntosList.splice(index, 1);
            }
        }
    }

    public imageUploading(args: any): void {
        if (args != null) {
            args.currentRequest.setRequestHeader(
                this.incidenciaUsuarioService.getAuthorizationHeaderParameterName(),
                this.incidenciaUsuarioService.getAuthorizationHeaderParameterValue()
            );
        }
    }

    public imageUploadSuccess(args: any): void {
        if (args != null && args.file != null) {
            let filename: any = document.querySelectorAll(".e-file-name")[0];

            if (filename != null) {
                filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, '');
                filename.title = args.file.name;
            }
        }
    }

    //Datos Persona/Vecino -------------------->

    buildPersonForm() {
        this.personaFormGroup = this.formBuilder.group({
            'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
            'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
            'TipoDocumentoId': [null],
            'NroDocumento': [null, Validators.maxLength(100)],
            'Cuit': [null],
            'FechaNacimiento': [null],
            'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
            'MovilContacto': [null, Validators.maxLength(100)],
            'DomicilioReal': [null, Validators.maxLength(150)]
        });
    }

    getTiposDocumento() {
        var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
        this.isTipoDocumentoSearching = true;

        this.tipoDocumentoService.search(r).subscribe(data => {
            this.isTipoDocumentoSearching = false;
            if (data != null) {
                this.tipoDocumentoList = data?.result;
            }
        },
            (err: HttpErrorResponse) => {
                this.isTipoDocumentoSearching = false;
                this.sharedFunctions.handleError(err);
            });
    }

    clearDatePersonForm(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.personaFormGroup?.get(formFieldName) != null && this.personaFormGroup?.get(formFieldName)?.value)
                this.personaFormGroup?.get(formFieldName)?.setValue(null);
        }
    }

    getErrorNombre() {
        var v = this.personaFormGroup?.get('Nombre');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorApellido() {
        var v = this.personaFormGroup?.get('Apellido');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorFechaNacimiento() {
        return this.personaFormGroup?.get('FechaNacimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    getErrorTipoDocumentoId() {
        return this.personaFormGroup?.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    getErrorNroDocumento() {
        var v = this.personaFormGroup?.get('NroDocumento');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorCuit() {
        var v = this.personaFormGroup?.get('Cuit');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorMovilContacto() {
        var v = this.personaFormGroup?.get('MovilContacto');
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        if(v?.hasError('required'))
            return 'El campo es obligatorio';
        return '';
    }

    getErrorDomicilioReal() {
        var v = this.personaFormGroup?.get('DomicilioReal');
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    loadPersonData() {
        if (this.persona != null && this.persona.Id !==null && this.persona.Id > 0) {
            if (this.canPersonEdit) {
                this.personaFormGroup.patchValue(this.persona);

                if (this.persona.FechaNacimiento != null)
                    this.personaFormGroup?.get("FechaNacimiento")?.setValue(this.datePipe.transform(this.persona.FechaNacimiento, "yyyy-MM-dd"));
            }
        }
    }

    getPersona() {
        this.isPersonaSearching = true;
        this.personaMsgError = "";
        if(this.item.PersonaId) {
          this.personaService.get(this.item.PersonaId).subscribe(data => {
              this.isPersonaSearching = false;
              if (data != null) {
                  this.persona = data.Result;
                  this.loadPersonData();

              }
              else
                  this.personaMsgError = "Ocurrió un error al intentar obtener los datos de la persona.";
          },
          (err: HttpErrorResponse) => {
              this.isPersonaSearching = false;
              this.sharedFunctions.handleError(err);
          })
        }
    }

    onPersonSearchClick() {
        if (this.isProcessing())
            return;

        const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
            width: '90%',
            data: new DialogPersonaSearchComponentRequestDto(false, 0)
        });

        dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
          if (result != null && !result.Cancelled) {
            var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

            this.persona = new Persona(0, null, null, null, null, null, null,null, null, null, true, null, null, null);
            if (u != null && u.Id !== null && u.Id > 0)
              this.persona = new Persona(u.Id, u.Nombre, u.Apellido, u.NroDocumento,u.TipoDocumentoNombre, u.TipoDocumentoId, u.FechaNacimiento, u.Cuit, u.MailContacto, u.MovilContacto,
                u.Activo, u.FotoDniFrenteUrl, u.FotoDniDorsoUrl, u.FotoSelfieUrl);

            this.loadPersonData();
          }
        });
    }

    onPersonDeassociateClick() {
    this.persona = new Persona(0, null, null, null, null, null, null, null, null,null, true, null, null, null);
    if (this.item != null)
        this.item.PersonaId = 0;
    this.loadPersonData();
    }

    canDeassociatePerson() {
        return this.canPersonEdit && this.persona != null && this.persona.Id !==null && this.persona.Id > 0;
    }

    getErrorCodigo() {
        var v = this.formGroup.get('Codigo');
        if(v?.hasError('required'))
            return 'El campo es obligatorio';
        return '';
    }

    getNombreCampo(item: IncidenciaUsuarioCategoria) {
        return this.item.IncidenciaUsuarioCategoriaCustom.find(x => x.Id == item.Id)?.NombreCampo;
    }

    getValorCampo(item: IncidenciaUsuarioCategoria) {
        return this.item.IncidenciaUsuarioCampoCustom.find(x => x.IncidenciaUsuarioCategoriaCustomId == item.Id)?.Valor
    }

    getErrorCampoCustom(campoCustom: string) {
        var v = this.camposCustomGroup.get(campoCustom);
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 255 caracteres alcanzado';
        return 'a';
    }

    getCampoActivo() {
        return this.categoriaCamposCustomList.some(x => x.Activo);
    }

    onCheckEnvioEmail(event) {
        this.mailPersona = this.personaFormGroup?.get("MailContacto")?.value;
        this.debeEnviarMail = event.checked;
        this.destinatarios = (this.mailProveedor == '' || this.mailProveedor == null) ? this.destinatarios : this.mailProveedor + ';'+ ((this.mailPersona == '' || this.mailPersona == null) ? this.destinatarios : this.mailPersona + ';' + this.destinatarios);

        console.log(this.destinatarios);
    }
}
